import { clientQuery } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { VEHICLE_REMOTE_COMMAND_FIELDS } from './remoteCommandFields';

/** First page: no cursor (the backend re-checks stale active commands only here). */
export const SEARCH_VEHICLE_REMOTE_COMMANDS_QUERY = `
	query searchVehicleRemoteCommands($unitId: Int!, $limit: Int) {
		RemoteCommands: searchVehicleRemoteCommands(unitId: $unitId, limit: $limit) {
			${VEHICLE_REMOTE_COMMAND_FIELDS}
		}
	}
`;

/** Next pages: keyset cursor `beforeId` = id of the last command already loaded. */
export const SEARCH_VEHICLE_REMOTE_COMMANDS_PAGE_QUERY = `
	query searchVehicleRemoteCommandsPage($unitId: Int!, $limit: Int, $beforeId: ID) {
		RemoteCommands: searchVehicleRemoteCommands(unitId: $unitId, limit: $limit, beforeId: $beforeId) {
			${VEHICLE_REMOTE_COMMAND_FIELDS}
		}
	}
`;

/**
 * One page of the unit's commands, newest first (general API, Cognito).
 * Without `beforeId` the cursor-less query is sent, so the first page keeps
 * working against a backend without the `beforeId` argument. Always an array.
 */
export const searchVehicleRemoteCommands = async (unitId, limit, beforeId) => {
	let query = SEARCH_VEHICLE_REMOTE_COMMANDS_QUERY;
	const variables = { unitId: Number(unitId), limit };
	if (beforeId !== undefined && beforeId !== null) {
		query = SEARCH_VEHICLE_REMOTE_COMMANDS_PAGE_QUERY;
		variables.beforeId = String(beforeId);
	}
	const res = await clientQuery(query, variables, endpoints.GRAPHQL_GENERAL_V2);
	return (res?.RemoteCommands ?? []).filter(Boolean);
};
